<div
    class="cp-import-container custom-grid"
    [matTooltip]="control.iconTooltip"
    matTooltipClass="mat-tooltip-cp"
    [hidden]="isHidden"
>
    <button *ngIf="onlyIcon" mat-icon-button [disabled]="isDisabled" (click)="onClick()">
        <mat-icon> {{ control.icon }} </mat-icon>
    </button>

    <button *ngIf="!onlyIcon" class="action-button" mat-stroked-button (click)="onClick()" [disabled]="isDisabled">
        <mat-icon class="icon"> {{ control.icon }} </mat-icon>
        {{ control.name | translate }}
    </button>
</div>
